/**
 * Labels a tracking point from the server's locationName (R15: the server names
 * points; the console never reverse-geocodes). A null name falls back to a plain
 * label; the caller shows the maps link for the coordinates.
 */
export function formatTrackingLocation(
  locationName: string | null | undefined,
  latitude?: number | null | undefined,
  longitude?: number | null | undefined,
): string {
  const cleanName = locationName?.trim();

  if (cleanName) {
    return cleanName;
  }

  const hasCoords =
    latitude != null &&
    longitude != null &&
    Number.isFinite(latitude) &&
    Number.isFinite(longitude);

  if (hasCoords) {
    return 'Location recorded';
  }

  return 'Location unavailable';
}

/**
 * Builds a direct Google Maps deep-link search URL centered on the coordinates.
 */
export function getGoogleMapsUrl(
  latitude: number | null | undefined,
  longitude: number | null | undefined,
): string | null {
  if (
    latitude != null &&
    longitude != null &&
    Number.isFinite(latitude) &&
    Number.isFinite(longitude)
  ) {
    return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  }
  return null;
}
